import { gql } from "@apollo/client";

export const GET_MOTIVO_LOGISTICA = gql`
    query AllMotivoLogistica{
        allMotivoLogistica{
            idGestionLogisticaMotivo
            descripcion
        }
    }
`;